<!-- eslint-disable no-undef -->
<script setup lang="ts">
defineProps<{
  isActive?: boolean;
  noPadding?: boolean;
}>();

const emit = defineEmits<{
  click: [];
}>();
</script>

<template>
  <div
    @click="emit('click')"
    class="list-item"
    :class="{
      'list-item--active': isActive,
      'list-item--no-padding': noPadding,
    }"
  >
    <slot></slot>
  </div>
</template>

<style scoped>
.list-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  /* height: 80px; */
  padding: 20px 12px;
  gap: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.16);
  transition: all 0.2s ease;
  cursor: pointer;
  position: relative;
}

.list-item--no-padding {
  padding: 0 !important;
}

.list-item--active {
  background-color: #702c2c33;
}

.list-item--active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(
    90deg,
    rgba(255, 195, 110, 0) 0%,
    rgba(255, 195, 110, 1) 50%,
    rgba(255, 195, 110, 0) 100%
  );
  /* box-shadow: 0 0 8px rgba(255, 195, 110, 0.6); */
}
</style>
